import { whyView } from "../insights/why-it-ranks.js";

/**
 * Why it ranks, in points (P43 of documentation/pr-plans/insights-simplify-plan.md, D147) on a card row's
 * Opportunity number (components/insights/why-it-ranks.blade.php), and the Current best search under the list's
 * first row's figure (D130; no longer inside the panel since D192). A row's view is worked out once for its factors:
 * P3's re-rank (writes.js placed()) gives a row new factors when it changes its search intent, so a stale view is
 * never drawn, and the panel's many bindings read one view.
 */
export default function whyPart() {
    const views = new WeakMap();

    return {
        whyOf(row) {
            const factors = row.detail.factors;
            const key = `${row.stage ?? ""}|${row.rawScore?.display ?? ""}`;
            const kept = views.get(factors);

            if (kept?.key === key) {
                return kept.view;
            }

            const view = whyView({ factors, stage: row.stage ?? null }, this.strings.why);
            views.set(factors, { key, view });

            return view;
        },

        // The current best search, the list's best row still to do of the most ready-to-buy search intent, says so
        // under its score (D130), and the label moves to the next once that search is done or moved. refresh()
        // works it out once per change (currentBestId); every binding here only compares ids.
        isCurrentBest(row) {
            return row !== null && row !== undefined && this.currentBestId !== null && this.currentBestId === row.id;
        },

        // A row's figure: its cell in the table's emphasized column, the Opportunity score's.
        whyFigure(row) {
            const column = this.table?.columns?.find((candidate) => candidate.emphasis);

            return column ? row?.cells?.[column.key] ?? null : null;
        },

        // The words under a card row's figure: Current best search on the current best, else the column's caption.
        figureCaption(row, column) {
            return this.isCurrentBest(row) && this.strings.why?.current_best ? this.strings.why.current_best : this.captionOf(column);
        },
    };
}
